<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>教程列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!--列表-->
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                  element-loading-text="拼命加载中" style="width: 100%;margin-top: 10px;">
            <el-table-column prop="title" label="标题" show-overflow-tooltip width="300"></el-table-column>
            <el-table-column prop="content" label="内容" show-overflow-tooltip>
                <template slot-scope="scope">
                    <div v-html="scope.row.content1" style="max-height: 30px;"></div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="150">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.row)">详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

        <!-- 编辑界面 -->
        <el-dialog :visible.sync="editFormVisible" width="70%" @click="closeDialog">
            <div class="title">{{editForm.title}}</div>
            <div v-html="editForm.content"></div>
        </el-dialog>
    </div>
</template>

<script>
    import Pagination from '../../components/Pagination'
    import {course} from "../../api/userMG";

    export default {
        data() {
            return {
                loading: false, //是显示加载
                editFormVisible: false, //控制编辑页面显示与隐藏
                title: '教程列表',
                formInline: {
                    page: 1,
                    limit: 10,
                    pageSize: 10
                },
                editForm: {
                    title: '',
                    content: '',
                    content1: '',
                    serial: '',
                },
                listData: [], //用户数据
                // 分页参数
                pageparm: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 10
                },
            }
        },
        // 注册组件
        components: {
            Pagination
        },
        /**
         * 创建完毕
         */
        created() {
            this.getdata(this.formInline)
        },

        /**
         * 里面的方法只有被调用才会执行
         */
        methods: {
            getdata(parameter) {
                this.loading = true
                course(parameter).then(res => {
                    this.listData = res.items
                    this.loading = false
                    this.pageparm.currentPage = this.formInline.page
                    this.pageparm.pageSize = this.formInline.limit
                    this.pageparm.total = res.pageInfo.total
                })
            },
            // 分页插件事件
            callFather(parm) {
                this.formInline.page = parm.currentPage
                this.formInline.limit = parm.pageSize
                this.formInline.pageSize = parm.pageSize
                this.getdata(this.formInline)
            },
            //显示编辑界面
            handleEdit: function (row) {
                this.editFormVisible = true
                if (row != undefined) {
                    this.editForm = row
                }
            },
            // 关闭编辑、增加弹出框
            closeDialog(formName) {
                this.editFormVisible = false
                this.$refs[formName].resetFields()
            }
        }
    }
</script>

<style scoped>
    .user-search {
        margin-top: 20px;
    }

    .title {
        text-align: center;
        margin-top: -30px;
        font-size: 1.2rem;
    }
</style>







// WEBPACK FOOTER //
// src/views/course/course.vue